import * as React from 'react';

import classnames from 'classnames';

import styles from './filter-drawer-main-content-wrapper.module.css';

type Props = {
    isFilterDrawerOpen: boolean;
    children: React.ReactNode;
    // Allows for the main content to be scrollable using the flex box approach
    hasFlex?: boolean;
    htmlId?: string;
};

export function FilterDrawerMainContentWrapper(props: Props) {
    return (
        <div
            id={props.htmlId}
            className={classnames(
                props.hasFlex ? 'flex flex-dir-col' : '',
                props.isFilterDrawerOpen ? styles['main-content--narrow'] : styles['main-content']
            )}
        >
            {props.children}
        </div>
    );
}
